import { Row, Skeleton, Statistic } from "antd";
import ResponsiveCol from "../form/ResponsiveCol";
import { ReactNode } from "react";
import { valueType } from "antd/lib/statistic/utils";

export interface SummaryItem {
  label: string;
  child: valueType;
  prefix?: ReactNode;
}

interface SummarySectionProps {
  title: string;
  items: SummaryItem[];
  isLoading: boolean;
}

function SummarySection({ title, items, isLoading }: SummarySectionProps) {
  return (
    <div style={{ background: "#E5E5E5", padding: "30px" }}>
      <Row gutter={24}>
        <ResponsiveCol>
          <h3 style={{ color: "#1B95CA", placeSelf: "center" }}>{title}</h3>
        </ResponsiveCol>

        {!isLoading &&
          items.map((item) => (
            <ResponsiveCol key={item.label}>
              <Statistic
                style={{ placeItems: "center" }}
                title={item.label}
                value={item.child}
                prefix={item.prefix}
              />
            </ResponsiveCol>
          ))}

        {isLoading && (
          <>
            <ResponsiveCol>
              <Skeleton loading active />
            </ResponsiveCol>
            <ResponsiveCol>
              <Skeleton loading active />
            </ResponsiveCol>
          </>
        )}
      </Row>
    </div>
  );
}

export default SummarySection;
